import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { BoothComponent } from './booth.component';
import { BoothDetailComponent } from './booth-detail.component';
import { BoothPopupComponent } from './booth-dialog.component';
import { BoothDeletePopupComponent } from './booth-delete-dialog.component';

import { Principal } from '../../shared';

export const boothRoute: Routes = [
  {
    path: 'booth',
    component: BoothComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.booth.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'booth/:id',
    component: BoothDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.booth.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const boothPopupRoute: Routes = [
  {
    path: 'booth-new',
    component: BoothPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.booth.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'booth/:id/edit',
    component: BoothPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.booth.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'booth/:id/delete',
    component: BoothDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.booth.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/booth/booth.route.ts